import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import Seo from '../../Components/Seo';

const Disclaimer = () => {
    return (
        <Container maxWidth="lg" sx={{ py: 6 }}>
            <Seo
                title="Medical Disclaimer"
                description="Medical disclaimer for Radiology Illustration. Content is educational and not a substitute for professional medical advice, diagnosis, or treatment."
                canonicalPath="/disclaimer"
            />
            <Paper elevation={3} sx={{ p: { xs: 3, md: 5 } }}>
                <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ fontWeight: 600 }}>
                    Disclaimer
                </Typography>

                <Box sx={{ mt: 4 }}>
                    <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
                        Medical Disclaimer
                    </Typography>
                    <Typography paragraph>
                        The content provided on this website, including text, graphics, images, and other material, is for educational and informational purposes only. It is intended to assist students, educators, and healthcare professionals in learning and understanding radiology and anatomy concepts.
                    </Typography>
                    <Typography paragraph>
                        <strong>Not Medical Advice:</strong> The information on this site is not intended to be a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition. Never disregard professional medical advice or delay in seeking it because of something you have read on this website.
                    </Typography>
                    <Typography paragraph>
                        <strong>No Doctor-Patient Relationship:</strong> Accessing or using this website does not create a doctor-patient relationship between you and Dr. Shubham Arora or any other contributors.
                    </Typography>
                    <Typography paragraph>
                        <strong>Accuracy:</strong> While we strive to provide accurate and up-to-date information, medicine is a constantly evolving field. We make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability, or availability of the information contained on the website.
                    </Typography>
                </Box>
            </Paper>
        </Container>
    );
};

export default Disclaimer;
